/** Recursively resolve default values for all ticket mode fields and their nested children */
export function getDefaultTicketModes(ticketModes: Array<App.TicketModeField>): Record<string, string> {
  let result: Record<string, string> = {}

  ticketModes.forEach(mode => {
    if (mode.default) {
      result[mode.key] = mode.default

      mode.options.forEach(option => {
        if (option.key === mode.default && option.fields) {
          result = { ...result, ...getDefaultTicketModes(option.fields) }
        }
      })
    }
  })

  return result
}

/** Combine ticket modes with pickup point field and sort by displayOrder (lower = rendered first, undefined = last) */
export type CombinedCheckoutField =
  | { type: 'ticketMode'; field: App.TicketModeField }
  | { type: 'pickup' }

export function getCombinedAndSortedCheckoutFields(
  ticketModes: Array<App.TicketModeField> | undefined,
  showPickup: boolean,
): Array<CombinedCheckoutField> {
  const fields: Array<CombinedCheckoutField> = []

  // Add ticket modes
  if (ticketModes?.length) {
    ticketModes.forEach(field => {
      fields.push({ type: 'ticketMode', field })
    })
  }

  // Add pickup point if applicable
  if (showPickup) {
    fields.push({ type: 'pickup' })
  }

  // Sort by displayOrder: lower numbers first, undefined last
  return fields.sort((a, b) => {
    const aOrder = a.type === 'ticketMode' ? a.field.displayOrder ?? Infinity : Infinity
    const bOrder = b.type === 'ticketMode' ? b.field.displayOrder ?? Infinity : Infinity
    return aOrder - bOrder
  })
}
